import { useMutation, useQueryClient } from '@tanstack/react-query';
import { companyService } from '../services/companyService';
import type { CreateCompanyPayload, CreateCompanyResponse } from '../types/newCompanyWizard.types';

/**
 * Hook to create a new company. On success, invalidates the companies list
 * and selected-company queries since the BFF auto-selects the new company
 * in the session.
 */
export function useCreateCompany() {
  const queryClient = useQueryClient();

  return useMutation<CreateCompanyResponse, Error, CreateCompanyPayload>({
    mutationFn: (payload) => companyService.createCompany(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['companies'] });
      queryClient.invalidateQueries({ queryKey: ['company', 'selected'] });
    },
  });
}
